import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

// Injector Total's X axis is a monthly (On Inj Date) time axis, so the X locks are kept as
// strings, mirroring trendDateLocks — only the Y (Well Count) locks are numeric.
export function injectorTotalLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;

  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset ? undefined : locks?.xMin?.value;
  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset ? undefined : locks?.xMax?.value;

  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;

  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;

  return {
    lockedXMin: lockedXMin?.toString(),
    lockedXMax: lockedXMax?.toString(),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
